<template>
    <v-stepper-content :step="step" class="text-center">
        <p v-for="(requirement, i) in requirements" :key="i">
            {{ requirement }}
        </p>

        <div class="mt-8">
            <v-btn
                @click="$emit('nextStep')"
                color="primary"
            >
                Selanjutnya
            </v-btn>
        </div>
    </v-stepper-content>
</template>

<script>
export default {
    props: {
        step: {
            type: String,
            required: true,
        }
    },

    computed: {
        requirements() {
            return this.$store.get('enrollment/selected@requirement')?.split('\n')
        }
    }
}
</script>
